import { apiClient } from '../../../api/httpClient';

export const getEmployeeInsightsStaff = (params) => (
  apiClient.get('/employee-insights/staff', { params })
);

export const getEmployeeInsightsStaffById = (id, params) => (
  apiClient.get(`/employee-insights/staff/${id}`, { params })
);

export const getEmployeeInsightsActivities = (params) => (
  apiClient.get('/employee-insights/activities', { params })
);

export const getEmployeeInsightsActivitySummary = (params, config = {}) => (
  apiClient.get('/employee-insights/activities/summary', {
    ...config,
    params,
  })
);

export const getEmployeeInsightsTasks = (params) => (
  apiClient.get('/employee-insights/tasks', { params })
);

export const getEmployeeInsightsWeeklyTargets = () => (
  apiClient.get('/employee-insights/staff/weekly-targets')
);
